import { PagedResponse } from "@ofqual/portal-core/core/types";
import { AnyAction } from "redux";
import { PendingReturn } from "../domain/PendingReturn";
import { MODULE_NAME } from "../moduleName";

export interface ActionPayload<T> extends AnyAction {
  type: string;
  payload: T;
}

export const LOADED_DATA_PORTAL_LOOKUP_LIST = `${MODULE_NAME}/LOADED_DATA_PORTAL_LOOKUP_LIST`;
export const LOADING_DATA_PORTAL_LOOKUP_LIST = `${MODULE_NAME}/LOADING_DATA_PORTAL_LOOKUP_LIST`;
export const UPDATED_DATA_PORTAL_LOOKUP_LIST = `${MODULE_NAME}/UPDATED_DATA_PORTAL_LOOKUP_LIST`;
export const UPDATING_DATA_PORTAL_LOOKUP_LIST = `${MODULE_NAME}/UPDATING_DATA_PORTAL_LOOKUP_LIST`;

export const LOADED_DATA_PORTAL_PREVIOUS_LIST = `${MODULE_NAME}/LOADED_DATA_PORTAL_PREVIOUS_LIST`;
export const LOADING_DATA_PORTAL_PREVIOUS_LIST = `${MODULE_NAME}/LOADING_DATA_PORTAL_PREVIOUS_LIST`;
export const UPDATED_DATA_PORTAL_PREVIOUS_LIST = `${MODULE_NAME}/UPDATED_DATA_PORTAL_PREVIOUS_LIST`;
export const UPDATING_DATA_PORTAL_PREVIOUS_LIST = `${MODULE_NAME}/UPDATING_DATA_PORTAL_PREVIOUS_LIST`;

export const SUBMIT_RETURN = `${MODULE_NAME}/SUBMIT_RETURN`;
export const SUBMIT_NIL_RETURN = `${MODULE_NAME}/SUBMIT_NIL_RETURN`;

export const FAILED_RETURN = `${MODULE_NAME}/FAILED_RETURN`;
export const SUCCESS_RETURN = `${MODULE_NAME}/SUCCESS_RETURN`;
export const ERROR_RETURN = `${MODULE_NAME}/ERROR_RETURN`;
export const RESET_SUBMISSION = `${MODULE_NAME}/RESET_SUBMISSION`;

export const loadedDataPortalLookups = (
  payload: PagedResponse<PendingReturn>
) => ({
  type: LOADED_DATA_PORTAL_LOOKUP_LIST,
  payload,
});

export const loadingDataPortalLookups = (orgId: number) => ({
  type: LOADING_DATA_PORTAL_LOOKUP_LIST,
  payload: { orgId },
});

export const updatedDataPortalLookups = () => ({
  type: UPDATED_DATA_PORTAL_LOOKUP_LIST,
});

export const updatingDataPortalLookups = (updates: Array<PendingReturn>) => ({
  type: UPDATING_DATA_PORTAL_LOOKUP_LIST,
  payload: { updates },
});

// Previous list actions
export const loadedDataPortalPreviousLookups = (
  payload: PagedResponse<PendingReturn>
) => ({
  type: LOADED_DATA_PORTAL_PREVIOUS_LIST,
  payload,
});

export const loadingDataPortalPreviousLookups = (orgId: number) => ({
  type: LOADING_DATA_PORTAL_PREVIOUS_LIST,
  payload: { orgId },
});

export const updatedDataPortalPreviousLookups = () => ({
  type: UPDATED_DATA_PORTAL_PREVIOUS_LIST,
});

export const updatingDataPortalPreviousLookups = (
  updates: Array<PendingReturn>
) => ({
  type: UPDATING_DATA_PORTAL_PREVIOUS_LIST,
  payload: { updates },
});

export const submitReturn = (fileName: string, collectionAoId: number, templateId: number) => ({
  type: SUBMIT_RETURN,
  payload: { fileName, collectionAoId, templateId }
});

export const submitNilReturn = (collectionAoId: number, templateId: number) => ({
  type: SUBMIT_NIL_RETURN,
  payload: { collectionAoId, templateId }
});

export const successReturn = (collectionAoId: number, templateId: number) => ({
  type: SUCCESS_RETURN,
  payload: { collectionAoId, templateId }
});

export const failedReturn = (collectionAoId: number, templateId: number, message?: string) => ({
  type: FAILED_RETURN,
  payload: { collectionAoId, templateId, message }
});

export const errorReturn = (collectionAoId: number, templateId: number) => ({
  type: ERROR_RETURN,
  payload: { collectionAoId, templateId }
});

export const resetSubmission = (key: string) => ({
  type: RESET_SUBMISSION,
  payload: { key } 
});